angular.module('cvsApp').controller('errorController', ['msgManagerService','validateDeepLinkModel', 'authenticateGuestUserModel','trackPackageModel','quickRegistrationModel','getSpecialtyWCMContentService', 'errorModel','webTrendsService','placeOrderService',function(MMS,VDLM,AGUM,TPM,QRM,WCM,EM,WTS,POS) {
	'use strict';
	var EC=this;
	EC.content={};
	/**
	 * SP 12/08/2016 - ITPR015400 - Guest Refill
	 * Added logic to read WCM content from common file and using v2.0 WCM content service
	 */
	EC.qRWcmContent = qRWcmContent;
	
	var contextInformation= VDLM.apiResponse.contextInformation ? VDLM.apiResponse.contextInformation.toUpperCase():undefined;
	//if(contextInformation && contextInformation=="TAP"){
		//WCM.getContent('TapErrors',onContentSuccessTAP);
	EC.content.trackPackageError = cvsUtility.addHardcodingTag(EC.qRWcmContent.tap_errors);
	//}else{
		//WCM.getContent('QRErrors',onContentSuccessQR);
	EC.content.quickRegistrationError=cvsUtility.addHardcodingTag(EC.qRWcmContent.qr_errors);
	//}
	
	if(AGUM.getError()!==""){
		EC.serviceError=false;
		if(AGUM.getError().statusCode==MMS.errorCodes().EXCEEDED_ATTEMPTS.code)
		{
			EC.maxAttemptError=true;
			WTS.webTrendsUtag("OBJ",{ 
					page_name:'srx: quickreg: registration locked',
					page_category:'specialty registration',
					page_error:cvsUtility.getPageError(AGUM, 'Fatal', 'authenticateGuestUser')
				});
		}else{
			backendError();
		}
	}else if(TPM.getError()!==""){
		EC.serviceError=false;
		EC.trackPackageError=false;
		if(TPM.getError().statusCode==MMS.errorCodes().TRACK_NOT_FOUND.code){
			EC.trackPackageError=true;
			WTS.webTrendsUtag("OBJ",{ page_name:'QR: Landing: Track a Package Error - Tracking Info Not Found',
			                    page_category:'Quick Registration',
			                    event_name: "Track Package",
			                    page_error:cvsUtility.getPageError(TPM, 'Fatal', 'authenticateGuestUser'),
			                    Page_Event:0
			 });
			
		}else{
			backendError();
		}
		
		
		
	}else if(QRM.getError()!==""){
		EC.serviceError=false;
		backendError();
	}else if(VDLM.getError()!==""){
		EC.serviceError=false;
		if(VDLM.getError().statusCode.replace('DBPL', '')==MMS.errorCodes().LINK_INVALID.code){
			EC.invalidEntryKey=true;
		}else if(VDLM.getError().statusCode.replace('DBPL', '')==MMS.errorCodes().LINK_EXPIRED.code){
			EC.linkExpired=true;
			WTS.webTrendsUtag("OBJ",{ page_name:'QR: Confirm ID/Track Package - Link Expired',
			                    page_category:'Quick Registration',
			                    event_name: "E-mail/SMS",
			                    page_error:cvsUtility.getPageError(VDLM, 'Fatal', 'validateDeepLink'),
			                    Page_Event:0
			        });
			
		}else if(VDLM.getError().statusCode.replace('DBPL', '')==MMS.errorCodes().LINK_LOCKED.code){
			EC.accountLocked=true;
			var pageErrorTap = "";
			if(VDLM.header.statusCode!=undefined && VDLM.header.statusDesc!=undefined)
			{
				pageErrorTap = VDLM.header.statusCode +"_"+ VDLM.header.statusDesc;
			}
			else if(VDLM.header.statusDesc!=undefined){
				pageErrorTap = VDLM.header.statusDesc;
			}
				WTS.webTrendsUtag("OBJ",{ page_name:'srx: quickreg: registration locked',
				page_category:'specialty registration',
				page_error:pageErrorTap
			});
		}else{
			backendError();
		}
	}else if(POS.getResponse()){
		EC.placeOrderService = true;
		EC.serviceError = false;
		

	}else {
		backendError();
	}


	function backendError(){
		EC.trackPackageBackendError = false;
			if(EM.getError()=="TAP"){
				WTS.webTrendsUtag("OBJ",{ page_name:'QR: Landing - Track a Package - Back-end / Technical Error',
				                    page_category:'Quick Registration',
				                    event_name: "Track Package",
				                    page_error:cvsUtility.getPageError(TPM, 'Fatal', 'authenticateGuestUser'),
				                    Page_Event:0
				 });
			}else if(EM.getError()=="QR"){
				WTS.webTrendsUtag("OBJ",{ page_name:'QR: Landing - Confirm ID and Reg Form - Back-end/Technical Error',
				                    page_category:'Quick Registration',
				                    event_name: "Track Package",
				                    page_error:cvsUtility.getPageError(VDLM, 'Fatal', 'validateDeepLink'),
				                    Page_Event:0
				 });
			}
			
			if(!cvsUtility.queryMap.accessKey){
				
				EC.invalidEntryKey=true;
				EC.serviceError=false;

			}else {
				if(EM.getError()=="TAP"){
					EC.trackPackageBackendError = true;
				}else{
					EC.serviceError=true;
				}
			}
			
	}
	function onContentSuccessQR(data) {
		if(data.getError() === '') {
			
			EC.content.quickRegistrationError = data.apiResponse.qr_errors;
		}
		else {
			//Fall back text
			var defaultContent = {
					qr_errors : {
						reg_locked_header: "Registration Locked",
						reg_locked_body: "We're sorry, but you have entered invalid information too many times. Please call us toll-free at <strong>1-800-237-2767</strong> if you need help.",
						reg_link_expired_header: "We're sorry, this link is no longer valid.",
        				reg_link_expired_body: "Your registration link has expired. Please &lt;a href='https://www.cvsspecialty.com/FASTPROXY/registration/#/registration'&gt; &lt;strong&gt;register your account&lt;/strong&gt;, &lt;/a&gt; or call &lt;a href='tel:1-800-237-2767'&gt; &lt;strong&gt;1-800-237-2767&lt;/strong&gt;&lt;/a&gt; (TTY: &lt;u&gt;711&lt;/u&gt;).",
						reg_unavailable: "We're sorry, but quick registration is currently unavailable. Please try again later. If the problem persists, please call us toll-free at <strong>1-800-237-2767</strong>for help.",
						reg_unavailable_landing: "We're sorry, but quick registration is currently unavailable. Please try again later.If the problem persists, please call us toll-free at <strong>1-800-237-2767</strong>for help.",
						rest_content: "",
						reg_link_invalid_header:"Invalid Link",
						reg_link_invalid_body:"Please call us toll-free at<strong>1-800-237-2767</strong> to request a new link."
					},
					tap_errors:{
						tap_not_found:"We're sorry, but we were unable to locate your tracking information. Please call us toll-free <strong>1-800-237-2767</strong> if you need help.",
						tap_unavailable:"We're sorry, but track a package is currently unavailable. Please try again later.If the problem persists, please call us toll-free at <strong> 1-800-237-2767</strong> for help."
					}
				};
			
			EC.content.quickRegistrationError=cvsUtility.addHardcodingTag(defaultContent.qr_errors);
			EC.content.trackPackageError = cvsUtility.addHardcodingTag(defaultContent.tap_errors);
		}
	}
	function onContentSuccessTAP(data) {
		if(data.getError() === '') {
			
			EC.content.trackPackageError = data.apiResponse.tap_errors;
		}
		else {
			//Fall back text
			var defaultContent = {
					tap_errors:{
						tap_not_found:"We're sorry, but we were unable to locate your tracking information. Please call us toll-free <strong>1-800-237-2767</strong> if you need help.",
						tap_unavailable:"We're sorry, but track a package is currently unavailable. Please try again later.If the problem persists, please call us toll-free at <strong> 1-800-237-2767</strong> for help."
					}
				};
			
			EC.content.trackPackageError = cvsUtility.addHardcodingTag(defaultContent.tap_errors);
		}
	}


}]);